var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 100,
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic_warning_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2655 0v1581H0V0h2655Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic_warning_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 0c27.614 0 50 22.386 50 50s-22.386 50-50 50S0 77.614 0 50 22.386 0 50 0Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic_warning_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.126 0c1.715 0 3.299.915 4.156 2.4l23.325 40.4a4.8 4.8 0 0 1-4.156 7.2H4.8a4.8 4.8 0 0 1-4.157-7.2L23.971 2.4A4.799 4.799 0 0 1 28.126 0Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic_warning_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.017 0a3.017 3.017 0 0 1 3.017 3.017v12.357a3.017 3.017 0 1 1-6.034 0V3.017A3.017 3.017 0 0 1 3.017 0Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic_warning_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.017 0a3.017 3.017 0 1 1 0 6.034 3.017 3.017 0 0 1 0-6.034Z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic_warning_svg__a)",
  transform: "translate(-69 -235)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic_warning_svg__b)",
  transform: "translate(69 235)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h100v100H0V0z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic_warning_svg__c)",
  transform: "translate(91 260)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3F5B73",
  d: "M0 0h56.25v50H0V0z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic_warning_svg__d)",
  transform: "translate(116.11 274.86)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F3CC53",
  d: "M0 0h6.034v18.391H0V0z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic_warning_svg__e)",
  transform: "translate(116.11 297.5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F3CC53",
  d: "M0 0h6.034v6.034H0V0z"
})))));
export default SvgIcWarning;